import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./CourseTeacher.module.scss";

export interface ICourseTeacherProps {
  teacherImgUrl: string,
  teacherName: string,
}

export const CourseTeacher: VoidFunctionComponent<ICourseTeacherProps> = ({teacherImgUrl, teacherName}) => {
  return (
    <li className={s.courseTeacher}>
      <img className={s.teacherImg} src={teacherImgUrl} alt={teacherName} width={"68"} height={"57"}/>
      <div className={s.teacherInfo}>
        <p className={s.teacherName}>{teacherName}</p>
      </div>
    </li>
  );
}

